import React from 'react';

const Tile = (props) => {
    const {
        file,
        onDelete = null
    } = props;

    const getIconClass = () => {
        if (!!file.icon && file.icon !== "") {
            return file.icon+" fa-3x";
        }

        return "fas fa-file fa-3x";
    }

    const renderControls = () => {
        if ((!file.url || file.url === "") && !onDelete) {
            return null;
        }

        return (
            <div className="dropdown">
                <button
                    className="dropdown-toggle cursor-pointer text-eh-mid-grey h3 mb-0 p-2"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <i className="far fa-ellipsis-h"/>
                </button>
                <div
                    className="dropdown-menu dropdown-menu-right p-0"
                    aria-labelledby="navbarDropdown"
                >
                    {!!file.url && file.url !== "" && (
                        <a className={"dropdown-item cursor-pointer"}
                           href={file.url}
                           target={'_blank'}
                        >
                            <span>View / Download</span>
                        </a>
                    )}
                    {!!onDelete && (
                        <button className={"dropdown-item cursor-pointer border-top"}
                                onClick={() => onDelete(file)}
                        >
                            <span>Delete</span>
                        </button>
                    )}
                </div>
            </div>
        )
    }

    return (
        <div className={"col col-6 col-md-4 col-xl-2 mb-3"}>
            <div className="file-gallery-tile p-2">
                <div className="tile-controls">
                    {renderControls()}
                </div>
                <div className={"icon-container pt-3 pb-2"}>
                    <i className={getIconClass()} />
                </div>
                <div className={"detail-container"}>
                    <div className={"details"}>
                        <div className={"upper-row mb-1 user-select-none"}>
                            {file.name}
                        </div>
                        <div className={"lower-row mb-0 user-select-none"}>
                            {!!file.created_at && file.created_at !== "" && (
                                <div>{file.created_at}</div>
                            )}
                            {!!file.display_size && file.display_size !== "" && (
                                <div>{file.display_size}</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Tile;
